/*
Sohel 11/02/2022 2699761741 Added Search Event Tactic Table
Sohel 11/02/2022 2699761741 Added fetch trigger group API
Sohel 11/02/2022 2699761741 payload changes
Sohel 11/03/2022 2699761741 label changes
Sohel 11/03/2022 2699761741 label changes
Sohel 11/05/2022 2699761741 rename tooltip
Rajesh 11/15/2022 2699761741 passing props to conditionally render add trigger button.
Rajesh 11/15/2022 2699761741 passing props to conditionally render group code and actions.
Prakash 11/16/2022 2699761741  removed toolbar for table.
Rajesh 11/15/2022 2699761741 passing props for component close.
Rajesh 11/18/2022 2699761741 removed passing props and condition for night jobs.
Sohel 11/14/2022 2699818958 Implemented run functionality
Sohel 11/18/2022 2699818958 payload changes
Sai maheshwar 11/19/2022 2699818958 fixed unable to see add event trigger group bug
Akhila 11/25/2022 2699818958 table title name change
akhila 11/26/2022 2699818958 changed titles for code and description
Sohel  12/05/2022 2699818958 Added Edit Icon and border to code
lalitha 12/09/2022 2699818958 Added Created Date column and payload
Raghu 12/12/2022 2699818958 Table Footer Syling Fixes
akhila 12/08/2022 2699818958 adding session storage for search items
Rajesh 12/15/2022 2699818958 added role access
kavyareddy 12/26/2022 2699818958 Fixed the eventType value issue
kavyareddy 12/26/2022 2699818958 Fixed rowsPerPagination issue
Dilip 12/30/2022 2699818958 renamed labels for code and description
Ashraf 01/04/2023 2699818958 fixed event type value disappear
Dilip 02/09/2023 2699818958 added created by dropdown
Raghu 02/22/2023 2699818958 added new class to button
Raghu 04/04/2023 2699818958 added add icon
Ravi 05/18/2023 2699818958 Added run buttton and integrated Api
Ravi 05/31/2023 2699818958 changed delete popup message
Akhila 06/08/2023 2699818958 created date change to date created field and column
Sohel 11/29/2023 2699818958 Removed Run Event Trigger Button
*/
import React, {useState, useEffect, createRef} from 'react';
import {Grid, TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../../constants/ReusableTablePagination';
import {httpPaginationDelete, httpPaginationPost} from './../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import DeleteTableRecordPopup from './../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import {ErrorSnackbar} from './../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from './../../../../components/CustomSnackBar/index';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {makeStyles} from '@material-ui/core';
import {
  fetchEventTriggerGroup,
  // postRunEventTrigger,
  resetRunTrigger,
  resetRunEventTrigger,
} from '../../../../redux/reducers/EventTriggerGroup';
import PageLoader from '../../../../components/PageLoader';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import moment from 'moment';
import {getOptions} from '../../../../util/GetDropDownOptions';
import {EVENT_TYPE_TRIGGER} from '../../../../constants/Lookup';
import {fetchCreatedByDropDownData} from '../../../../redux/reducers/ReportMaster';
import AddIcon from '@material-ui/icons/AddOutlined';
export default function TriggerSearchTable({
  searchData,
  setSubmit,
  submit,
  setValue,
  setRunClicked,
  setRowData,
  nightJobSearchTrigger,
  setSearchTrigger,
  setTriggerSearchCode,
}) {
  const [arrayLast, setArrayLast] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [deleteData, setDeleteData] = useState({});
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [status, setStatus] = useState(false);
  const tableRef = createRef();
  const dispatch = useDispatch();
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Event Triggers']?.['ET'];
  const {successMsg, errorMsg, isLoading, runTriggerStatus, runEventTriggerStatus} = useSelector(
    ({eventTriggerGroup}) => eventTriggerGroup,
  );
  const {dispositionDropDown} = useSelector(({addEventTactic}) => addEventTactic);
  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();

  const getTypeOption = (option) => {
    const options = getOptions(EVENT_TYPE_TRIGGER, dispositionDropDown);
    return options && options?.find((item) => item?.valueCode === option);
  };

  useEffect(() => {
    tableRef?.current?.onQueryChange();
  }, [dispositionDropDown]);

  const columns = [
    {
      title: 'Event Trigger Name',
      field: 'groupCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            dispatch(fetchEventTriggerGroup(rowData?.groupId));
            setValue(1);
          }}
        >
          {rowData?.groupCode ? rowData.groupCode.replace(/ /g, '\u00a0') : ""}
        </span>
      ),
    },
    {
      title: 'Event Trigger Description',
      field: 'groupDescription',
      render: (rowData) => (
        <>
          <div>
            {rowData.groupDescription ? rowData.groupDescription.replace(/ /g, '\u00a0') : ""}
          </div>
        </>
      ),
    },
    {
      title: 'Event Type',
      field: 'event',
      render: getTypeOption(),
    },
    {
      title: 'Value',
      field: 'fieldValue',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
  ];

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const [rows, setRows] = useState(defaultRows);

  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };

  const handleClose = () => {
    setIsDelete(false);
  };
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetRunTrigger());
        dispatch(resetRunEventTrigger());
      }, 2000);
    }
  }, [successMsg, errorMsg, runTriggerStatus, runEventTriggerStatus]);
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  const handleSubmit = () => {
    httpPaginationDelete(`event/delete/eventtrigger/${deleteData?.groupId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('eventtrigger'));
      setStatus(false);
    }
  }, [status]);

  const SearchSessionEvent = JSON.parse(sessionStorage.getItem('EventTriggerGroup'));
  if (SearchSessionEvent && !submit) {
    searchData = SearchSessionEvent;
  }

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Event Trigger"
        value={`Are you sure you want to delete the ${deleteData?.groupCode?.replace(/ /g, '\u00a0')} Event Trigger?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12}>
        <div className="new-standard-textfields custom-table global-field-table custom-toolbar-icons custom-actions-icon tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `event/trigger/search/all`;

                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  groupCode: searchData?.code ? searchData?.code : '',
                  event: searchData?.eventType?.valueCode ? searchData?.eventType?.valueCode : '',
                  groupDescription: searchData?.description ? searchData?.description : '',
                  fieldValue: searchData?.fieldValue ? searchData?.fieldValue : '',
                  orderDirection: query?.orderDirection,
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  search: query?.search ? query?.search : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject?.map((e) => ({
                          ...e,
                          event: getTypeOption(e.event)?.value,
                        }));

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              toolbar: true,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                disabled: !disable?.edit,
                onClick: (event, rowData) => {
                  dispatch(fetchEventTriggerGroup(rowData?.groupId));
                  setValue(1);
                },
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  disabled: !disable?.delete,
                  onClick: () => {
                    handleDelete(rowData);
                  },
                };
              },
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      disabled={!disable?.add}
                      startIcon={<AddIcon />}
                    >
                      Add Event Trigger
                    </Button>
                  </>
                ),
                disabled: !disable?.add,
                isFreeAction: true,
                onClick: () => setValue(1),
              },
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="outlined"
              //         className={`search-btn`}
              //         disabled={!disable?.add && !disable?.edit}
              //       >
              //         Run Event Trigger
              //       </Button>
              //     </>
              //   ),
              //   disabled: !disable?.add && !disable?.edit,
              //   isFreeAction: true,
              //   onClick: () => dispatch(postRunEventTrigger()),
              // },
            ]}
          />
        </div>
      </Grid>
      {isLoading && <PageLoader />}
      {(deleteErrorMsg || errorMsg) && <ErrorSnackbar errorMsg={deleteErrorMsg || errorMsg} />}
      {(tstmsg || successMsg) && <SuccessSnackbar successMsg={tstmsg || successMsg} />}
    </>
  );
}
